import React from 'react';
import { Grid } from '@cp/ds/src/components/grid';
// import { newCareersDict } from '@common/const/catalog';
import { coreCareerApi } from '@cp/entities/career';
import { CareerButton } from 'src/app/shared/components/careerButton';
import { ClientRegistrationStepProps } from './model';

export const StepCareer: React.FC<ClientRegistrationStepProps> = (props) => {
  const clickHandler = (mainCareerId: number) => {
    return props.onSubmit({ mainCareerId });
  };
  const { data: careerDictionary } = coreCareerApi.endpoints.getCareers.useQuery();
  const items = React.useMemo(
    () =>
      Object.entries({ ...careerDictionary /*, ...newCareersDict*/ }).map(
        ([careerId, careerViewModel]) => [Number(careerId), careerViewModel] as const,
      ),
    [careerDictionary],
  );
  return (
    <Grid container spacing={1} sx={{ flexWrap: 'wrap', px: { xs: 2.5, md: 0 } }}>
      {items.map(([careerId, careerViewModel]) => (
        <Grid item key={careerId} sx={{ display: 'flex' }} xs={6}>
          <CareerButton
            careerId={careerId}
            label={careerViewModel.translation.namePlural}
            onClick={'isActive' in careerViewModel && !careerViewModel.isActive ? undefined : () => clickHandler(careerId)}
          />
        </Grid>
      ))}
    </Grid>
  );
};
